import * as S from './AttributionSubChannel.styles'

export default function AttributionSubChannel({
  text,
  onClick,
}: {
  text: string
  onClick: (e: React.MouseEvent<HTMLDivElement>) => void
}) {
  return (
    <S.Container onClick={onClick}>
      <S.Arrow />
      <S.Option>{text}</S.Option>
    </S.Container>
  )
}
